import 'tippy.js/dist/tippy.css'; // optional for styling
import '../scss/main.scss';
import 'jquery-modal/jquery.modal.css';
import 'jquery-modal';
import './jquery.cookie-1.4.1.min';

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import tippy, {followCursor, hideAll} from 'tippy.js';
import 'tippy.js/animations/scale.css';


window.$ = jQuery;

/**
 * https://github.com/NTag/dotted-map
 */
// import DottedMap from './dotted-map';
// import './dotted-map-zoom';


/**
 * Check if loaded in iframe
 */
require('./parallax');
//require('./gallery-temp'); GSAP gallery slider with scroll
require('./easings');

import './jQuery-plugin-progressbar';
import 'jquery.transit';

import Packery from 'packery'


import 'slick-carousel'
import './waves'
import './insights-pagination'
import './work-pagination'
import './self-audit-calculator'
import './bianca'


(($) => {


    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    $("body:not(.et-fb-root-ancestor) .team-slider").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        infinite: true,
    })






    window.agencySlider = $("body:not(.et-fb-root-ancestor) .agency-services-slider >div")

    // agencySlider.removeClass('et_pb_row et_pb_equal_columns et_pb_gutters1')
    // agencySlider.parent().removeClass('et_pb_section agency-services-slider et_pb_with_background et_section_regular')

    agencySlider.slick({
        autoplay: true,
        autoplaySpeed: 2000,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
        // draggable: false,
        // swipe: false,
    })

    let xCoordStart,
        yCoordStart,
        xSlideTrigger = 10,
        slickElement = $("body:not(.et-fb-root-ancestor) .agency-services-slider>div,.mobile-testimonial-container")

    slickElement.bind('touchstart', function (e){
        console.log(e)
        xCoordStart = e.originalEvent.touches[0].clientX;
        yCoordStart = e.originalEvent.touches[0].clientY;
    });

    slickElement.bind('touchend', function (e){

        var xCoordEnd = e.originalEvent.changedTouches[0].clientX;
        var yCoordEnd = e.originalEvent.changedTouches[0].clientY;

        var deltaX = Math.abs(xCoordEnd - xCoordStart)
        var deltaY = Math.abs(yCoordEnd - yCoordStart)

        if(deltaX > deltaY){  // prevent slide while scrolling vertically
            if(xCoordStart > xCoordEnd + xSlideTrigger){
                e.preventDefault()
                slickElement.slick('slickNext');
            }
            else if(xCoordStart < xCoordEnd + xSlideTrigger){
                e.preventDefault()
                slickElement.slick('slickPrev');
            }
        }

    });


    // let xStart, xEnd;
    //
    // agencySlider.on("touchstart", function (e) {
    //     console.log(e)
    //     if (e.originalEvent.pageX) {
    //         xStart = e.originalEvent.pageX;
    //     } else {
    //         xStart = e.originalEvent.touches[0].pageX;
    //     }
    // })
    //     .on("touchmove", function (e) {
    //         console.log(e)
    //         if (e.originalEvent.pageX) {
    //             xEnd = e.originalEvent.pageX;
    //         } else {
    //             xEnd = e.originalEvent.touches[0].pageX;
    //         }
    //     })
    //     .on("touchend", function (e) {
    //         console.log(e)
    //         var deltaX = xEnd - xStart;
    //
    //         if (deltaX < 0) {
    //             agencySlider.slick("slickNext");
    //         } else {
    //             agencySlider.slick("slickPrev");
    //         }
    //     });

    agencySlider.on('afterChange', function () {
        setTimeout(() => {
            $(document).trigger("parallaxRefresh");
        }, 100)
    });
    agencySlider.on('init', function () {
        $(document).trigger("parallaxRefresh");
    });











    $("body:not(.et-fb-root-ancestor) .slider.single-item").slick({
        // autoplay: true,
        autoplaySpeed: 2000,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        infinite: true,
    })
    $(".insights-carousel >div").slick({

        // normal options...
        infinite: true,

        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }

            },
            {
                breakpoint: 670,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }

            },
        ]

    });


// $(document).ready(function () {
//     if (typeof $.cookie('rebrand-notice-dismissed') === 'undefined') {
//         $('#rebrand-modal').modal({
//             fadeDuration: 200
//         });
//
//         $(document).on('click', '#rebrand-modal a[rel="modal:close"]', function (event, modal) {
//             $.cookie('rebrand-notice-dismissed', 'true', {expires: 30, path: '/'});
//         });
//     }
// })


    /**
     * Overwrite the animation of the divi accordion
     */
    $('body').off('click', '.et_pb_toggle_title, .et_fb_toggle_overlay');
    $('.et_pb_toggle').click(function (e) {
        $(this).children('.et_pb_toggle_content').toggle('fast');
        $(this).toggleClass('et_pb_toggle_close et_pb_toggle_open');
    })


    window.isScrolledIntoView = (elem) => {
        const item = document.querySelectorAll('body:not(.et-fb) svg.fdc-animate-svg')[0];

        var bounding = item.getBoundingClientRect(),
            myElementHeight = item.offsetHeight,
            myElementWidth = item.offsetWidth;

        if (bounding.top >= -myElementHeight
            && bounding.left >= -myElementWidth
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
            && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {
            return true;
        } else {
            return false;
        }


    }


    const fdcAnimateSvg = document.querySelector('body:not(.et-fb) svg.fdc-animate-svg');
    if (fdcAnimateSvg) {
        const fdcAnimateSvgObserver = new IntersectionObserver(entries => {
            setTimeout(() => {
                fdcAnimateSvg.classList.toggle('in-viewport', entries[0].isIntersecting);
            }, 500)
        });

        fdcAnimateSvgObserver.observe(fdcAnimateSvg);
    }


    $('.team-grid-marquee, .team-gallery-slider').each(function () {
        const fdcAnimateTeamObserver = new IntersectionObserver(entries => {
            setTimeout(() => {
                this.classList.toggle('paused', !entries[0].isIntersecting);
            }, 500)
        });

        fdcAnimateTeamObserver.observe(this);
    })


    $(function () {
        $(document).scroll(function () {
            const header = $("#header"),
                topbar = $('#topbar'),
                navHeight = 100//header.height()+topbar.height();

            header.removeClass('offset-top').toggleClass('scrolled', $(this).scrollTop() > navHeight);

            if (!window.fdcUseParallax) {
                if ($(this).scrollTop() > navHeight) {
                    topbar.slideUp(300);
                } else {
                    topbar.slideDown(300);
                }
            }
        });
    });

    $(document).ready(function () {
        const header = $("#header"),
            topbar = $('#topbar'),
            navHeight = 100

        header.toggleClass('scrolled offset-top', $(this).scrollTop() > navHeight);

        if (!window.fdcUseParallax && $(this).scrollTop() > navHeight) {
            topbar.hide()
        }


        /**
         * TODO remove after live
         * continue here !!!
         */
        // header.addClass('dropdown-open');


        // $('#nav-items .menu-main-menu-container > .dropdown-nav-item >div')
        //     .on('mouseover', function (event) {
        //         $(this).addClass('dropdown-child-hover')
        //     })
        //     // .on('mouseleave', function (event) {
        //     //     $(this).remove('dropdown-child-hover')
        //     //     header.removeClass('dropdown-open');
        //     // })

        $('#nav-items .menu-main-menu-container > .dropdown-nav-item')
            .on('mouseover', function () {
                header.addClass('has-dropdown-open');
            })
            .on('mouseleave', function (event) {
                // if (!$(this).children('.dropdown-child-hover'.length)) {
                header.removeClass('has-dropdown-open');
                // }
            })


        // $(document).click(function (event) {
        //     $('#nav-items >div>div.dropdown-nav-item.is-open').removeClass('is-open')
        // })

        const mobileWidthBreakpoint = parseInt($('#header').css('--mobileWidthBreakpoint').replace('px', ''));


        $('#nav-items >div>div.dropdown-nav-item>a').each(function () {
            $(this).prepend('<div class="nav-dropdown-btn"/>')
        })


        $(document).on('click', '#toggle-mobile-nav', function () {
            $('body').toggleClass('mobile-nav-open')

            if (typeof showTopbar !== 'undefined') {
                if ($('body').hasClass('mobile-nav-open')) {
                    // $('#topbar').slideUp(150)
                    showTopbar.reverse()
                } else {
                    // $('#topbar').slideDown(150)

                    if (!$('body').hasClass('hide-topbar')) {
                        showTopbar.play()
                    }
                }
            }
            $('#nav-items >div>div.dropdown-nav-item.is-open').removeClass('is-open').children('div').slideUp(150)

        })


        $(document).on('click', '#nav-items >div>div>a .nav-dropdown-btn', function (event) {

            console.log(event.relatedTarget)

            const button = $(this),
                link = button.parent(),
                container = link.parent()
            event.preventDefault()

            if ($(window).width() < mobileWidthBreakpoint) {

                $('#nav-items >div>div.dropdown-nav-item.is-open').not(container).removeClass('is-open').children('div').slideUp(150);

                if (!container.hasClass('is-open')) {
                    container.addClass('is-open')
                    container.children('div').slideDown(150);
                } else {
                    container.removeClass('is-open')
                    container.children('div').slideUp(150);
                }
            }

            return false

        })


        $('.hover-stat-reveal .et_pb_column').each(function () {
            $(this)
                .addClass('gallery-cell flippable-card flippable')
                .find('>div').wrapAll("<div class='flippable-wrapper'></div>")

            $(this).find('.et_pb_module').addClass('card__face').wrapInner("<div class='card_contents'></div>")
            $(this).find('.et_pb_module').first().addClass('card__face--front')
            $(this).find('.et_pb_module').last().addClass('card__face--back')
        })
    })

    $(document).on('click', '.business-unit-buttons button', function () {
        let button = $(this),
            tab = $(`.${button.data('tab')}`)

        $('.business-unit-buttons button').not(button).removeClass('active')
        button.addClass('active')


        $('.home-animated-svg').not(tab).hide().find('svg.fdc-animate-svg').removeClass('in-viewport')
        tab.show()
        tab.find('svg.fdc-animate-svg').addClass('in-viewport')

    })


    window.initTooltips = () => {
        window.tippyInstances = tippy('[data-tippy-content]', {
            arrow: false,
            animation: 'scale',
            // trigger: 'click',
            followCursor: true,
            plugins: [followCursor],
        });

    }


    /**
     * Homepage footprint map
     */
    if (typeof footprintLocations !== 'undefined') {
        /**
         * Update the location label background width to match text and add padding
         */
        $(document).ready(function () {


            initTooltips()

            $(document).on('click', '#footprint-pins', function () {
                $('#our-footprint-map-v2 img').trigger('click')
            })

            $(document).on('click', '.footprint-pin >div>div', function (event) {
                $('#our-footprint-map-v2 img').trigger('click')
                event.preventDefault()
                event.stopImmediatePropagation()
                return false
            })

            Fancybox.bind("[data-fancybox]", {

                on: {
                    "*": (fancybox, eventName) => {

                        // console.log(eventName)

                        if ('Carousel.Panzoom.touchMove' === eventName) {
                            hideAll();
                        }

                        if ('Carousel.createSlide' === eventName) {
                            $('.fancybox__content').append($('.footprint-pins').clone().removeAttr('id'))
                            initTooltips()
                        }
                    },
                    ready: (fancybox, slide) => {
                        // modal is open pause ScrollSmoother
                        // window.scroller.paused(true);
                        window.scroller.kill()
                    },
                    destroy: (fancybox, slide) => {
                        // modal is closed un-pause ScrollSmoother
                        // window.scroller.paused(false);
                        window.scroller = initSmoothScroller()
                    },
                }
            });


        })


    }


    /**
     * Fix scroll
     */
    if ($('.marquee-clients false').length) {

        const slider = document.querySelector('.marquee-clients');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;

            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;

// $('.marquee-clients__content').css('transform','translateX(calc('+startX+'% - var(--gap)))')


            e.preventDefault()
            return false

        });
        slider.addEventListener('mouseleave', (e) => {
            isDown = false;
            // slider.classList.remove('scrolling');
            setTimeout(() => {
                slider.classList.remove('scrolling');
            }, 10)
        });
        slider.addEventListener('mouseup', (e) => {
            isDown = false;
            setTimeout(() => {
                slider.classList.remove('scrolling');
            }, 10)
            // slider.classList.remove('scrolling');
        });
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            slider.classList.add('scrolling');
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX); //scroll-fast

            $('.marquee-clients__content').css('transform', 'translateX(calc(' + (scrollLeft - walk) + '% - var(--gap)))')

            slider.scrollLeft = scrollLeft - walk;
        });


        slider.addEventListener("wheel", (evt) => {

            // slider.scrollLeft += evt.deltaY;

            $('.marquee-clients__content').css('transform', 'translateX(calc(' + (evt.deltaY) + '% - var(--gap)))')

            // if (slider.scrollLeft !== 0) {
            //     evt.preventDefault();
            // }

        });
    }


    $('.wpforms-container form textarea').each(function () {
        this.setAttribute("style", "height:" + (this.scrollHeight + 1) + "px;overflow-y:hidden;");
    }).on("input", function () {
        this.style.height = 0;
        this.style.height = (this.scrollHeight + 4) + "px";
    });


// const servicesFloatingImage = document.querySelector('#post-93 .services-floating-image >.et_pb_row:first-of-type')
// if (servicesFloatingImage) {
//     const observer = new IntersectionObserver(entries => {
//         entries.forEach(entry => {
//             const section = $(entry.target).parents('.services-floating-image')
//             if (entry.isIntersecting) {
//                 section.addClass('rotate-image');
//                 return; // if we added the class, exit the function
//             }
//
//             // We're not intersecting, so remove the class!
//             section.removeClass('rotate-image');
//         });
//     });
//
//     observer.observe(document.querySelector('#post-93 .services-floating-image >.et_pb_row:first-of-type'));
// }

// $('.et_pb_video ').remove()


    $(".mobile-testimonial-container").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        autoplaySpeed: 100,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        infinite: true,
    })


    $('.mobile-testimonial-container').on('afterChange', function () {
        setTimeout(() => {
            $(document).trigger("parallaxRefresh");
        }, 100)
    });
    $('.mobile-testimonial-container').on('init', function () {
        $(document).trigger("parallaxRefresh");
    });


    $(document).on('click', '.testimonial-container .person:not(.show)', function () {
        let button = $(this),
            buttonPositionTop = button.position().top,
            buttonHeight = button.outerHeight(),
            list = button.parents('.testimonial-container').find('.list'),
            listHeight = list.outerHeight(),
            listScrollTop = list.scrollTop(),
            listPositionTop = list.position().top,
            id = button.data('person'),
            detail = $(`.testimonial-container > .details > .detail[data-person="${id}"]`)


        // console.log({
        //     buttonPositionTop,
        //     buttonHeight,
        //     listPositionTop,
        //     listHeight,
        //     listScrollTop
        // })
        //
        //
        //
        // console.log(buttonPositionTop - listPositionTop - (listHeight/2))


        list.animate({
            scrollTop: buttonPositionTop - listPositionTop - (listHeight / 2) + listScrollTop + (buttonHeight / 2)
        }, 500);


        button.addClass('show')

        $('.testimonial-container .person').not(button).removeClass('show')
        $(`.testimonial-container > .details > .detail`).not(detail).removeClass('show').hide()
        detail.fadeIn('fast')

    })


    $('img').removeAttr('title');


// const linkedinCounter = document.querySelector('.linkedin-counter')
// if (linkedinCounter) {
//     const observer = new IntersectionObserver(entries => {
//         entries.forEach(entry => {
//             const section = $(entry.target)
//             if (entry.isIntersecting) {
//                 section.loading();
//                 return; // if we added the class, exit the function
//             }
//
//             // We're not intersecting, so remove the class!
//             section.html('');
//         });
//     });
//
//     observer.observe(document.querySelector('.linkedin-counter'));
// }


    $(".linkedin-counter").loading();

    $(".linkedin-counters").each(function () {
        let $this = $(this),
            $dataV = $this.data("percent"),
            $dataDeg = $dataV * 3.6,
            usesIcon = $this.hasClass('tp-costs') || $this.hasClass('tp-welfare')

        console.log($dataV)
// console.log(usesIcon)
        $this.html('<div class="circle_inner"><div class="round_per"></div></div>')
        let $round = $this.find(".round_per");
        $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
        $this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
        $this.prop('Counter', 0).animate({Counter: $dataV},
            {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                    if (!usesIcon) {
                        $this.find(".percent_text").text(Math.ceil(now) + "%");
                    }
                }
            });

        if ($dataV >= 51) {
            $round.css("transform", "rotate(" + 360 + "deg)");
            setTimeout(function () {
                $this.addClass("percent_more");
            }, 1000);
            setTimeout(function () {
                $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
            }, 1000);
        }
    });

    $(document).ready(function () {
        if ($('#linkedin-social-selling-header-image').length) {
            const positionLinkedinProfileImage = () => {
                const container = $('#linkedin-social-selling-header-image'),
                    firstSection = $('.et_pb_section:nth-of-type(1)'),
                    offsetTop = firstSection.outerHeight() - container.outerHeight(),
                    offsetLeft = container.offset().left,
                    rowHeight = $('.et_pb_section_0 .et_pb_row').outerHeight(),
                    heading = $('.et_pb_section_0 .et_pb_row h1'),
                    headingWidth = heading.outerWidth(),
                    headingOffsetRight = ($(window).width() - (heading.offset().left + heading.outerWidth())) - 100;

                $('.et_pb_section_1').css('padding-top', 130)

                if (container.outerWidth() > headingOffsetRight) {
                    // container.css('right', '250px').css('top', `${offsetTop}px`)
                    $('.et_pb_section_0').css('padding-bottom', container.outerHeight() - 100)
                    container.css('right', '').css('top', `${offsetTop}px`).addClass('mobile')
                    $('.et_pb_section_0 .et_pb_row').css('padding-bottom', 100)
                } else {
                    container.css('right', '100px').css('top', `${offsetTop}px`).removeClass('mobile')
                    $('.et_pb_section_0').css('padding-bottom', '')
                    $('.et_pb_section_0 .et_pb_row').css('padding-bottom', '')
                }


            };
            positionLinkedinProfileImage()

            $(window).resize(function () {
                positionLinkedinProfileImage()
            });
        }
    })


    if ($('.team-header .team-grid').length) {
        let pckry = new Packery('.team-header .team-grid', {
            stamp: '.stamp',
            gutter: 10,
            itemSelector: '.team-member',
            originLeft: false

        });


        $(document).on('click', '.team-header .team-member', function (event) {
            // change size of item by toggling large class

            $('.team-header .team-member').not($(event.currentTarget)).removeClass('expanded').find('.info').slideUp('fast')


            $(event.currentTarget).toggleClass('expanded').find('.info').toggle();
            // trigger shiftLayout after item size changes
            // pckry.shiftLayout()
            $(window).resize(function () {
                pckry.shiftLayout()
            })
        });
    }


// if ($('.team-header_v2 .team-grid').length) {
//     $(document).on('click', '.team-header_v2 .team-member', function (event) {
//         // change size of item by toggling large class
//
//         $('.team-member').not($(event.currentTarget)).removeClass('expanded').find('.info')
//         $(event.currentTarget).toggleClass('expanded')
//     });
// }

    if ($('.team-header_v3 .team-grid, .team-header_v2 .team-grid').length) {
        $(document).on('click', '.team-header_v3 .team-member', function (event) {
            expandTeamCard(event)
        });
        $(document).on('click', '.team-header_v2_1 .team-member', function (event) {
            expandTeamCard(event)
        });
    }

    const expandTeamCard = (event) => {
        $('.team-member').not($(event.currentTarget)).removeClass('expanded shift-card-left shift-card-right')

        $(event.currentTarget).removeClass('shift-card-left shift-card-right')
        if ($(event.currentTarget).hasClass('expanded')) {
            $(event.currentTarget).removeClass('expanded')
        } else {
            $(event.currentTarget).addClass('expanded')
            $(event.currentTarget).prevAll().addClass('shift-card-left')
            $(event.currentTarget).nextAll().addClass('shift-card-right')
            $(event.currentTarget).parent().prev().find('.team-member').addClass('shift-card-left')
            $(event.currentTarget).parent().next().find('.team-member').addClass('shift-card-right')
        }
    }

    if ($('.team-gallery-slider').length) {
        $('.team-gallery-slider').append($('.team-gallery-slider .et_pb_column').clone().attr('aria-hidden', true))
    }


    if ($('.vacancies-list').length) {

        let listContainer = $('.vacancies-list')

        $.ajax({
            method: 'GET',
            url: 'https://flance.bamboohr.com/jobs/embed2.php',
            mode: 'no-cors',
            headers: {
                accept: 'application/json'
            },
            success(data) {

                let parser = new DOMParser();
                let doc = parser.parseFromString(data, 'text/html');
                let list = doc ? doc.querySelectorAll('ul.BambooHR-ATS-Department-List > li') : []
                if (list.length) {

                    let items = '<div class="vacancies">'
                    list.forEach((category, key) => {
                        let department = category.querySelector('.BambooHR-ATS-Department-Header').textContent
                        let positions = category.querySelectorAll('.BambooHR-ATS-Jobs-List > li')
                        if (positions && positions.length) {
                            positions.forEach((position, pkey) => {
                                // console.log(position)
                                let positionName = position.querySelector('a')
                                let location = position.querySelector('span.BambooHR-ATS-Location')
                                // console.log(positionName)
                                if (positionName) {
                                    items = items + `
                                <div class="vacancy">
                                <div class="container">
                                <a rel="noreferrer noopener" target="_blank" href="${positionName.getAttribute('href')}">
                                <div class="position"><div>${positionName.textContent}</div></div>
                                <div class="department"><div>${department}</div></div>
                                <div class="location"><div>${location ? location.textContent : ''}</div></div>
                                </a>
                                </div>
                                </div>
                                `
                                    // items.push({
                                    //     department,
                                    //     positionName: positionName.textContent,
                                    //     link: positionName.getAttribute('href'),
                                    //     location: location ? location.textContent : ''
                                    // })
                                }
                            })
                        }
                    })
                    items = items + '</div>'
                    listContainer.html(items)
                } else {
                    listContainer.html('<h3>No vacancies open at the moment. Please check back later.</h3>')
                }
                $(document).trigger("parallaxRefresh");
            },
            error() {
                listContainer.html('<h3>Unable to load vacancies. Please reload the page or try again later.</h3>')
            }

        })

    }


// ( function( $ ) {
//     $( document ).on( 'mousewheel DOMMouseScroll', function( event ) {
//         if ( ( $( '.et_pb_side_nav' ).length === 0 ) || $( 'html, body' ).is( ':animated' ) ) return;
//         event.preventDefault();
//         let direction = event.originalEvent.wheelDelta || -event.originalEvent.detail,
//          $position = $( '.et_pb_side_nav' ).find( '.active' ),
//          $target,
//         header = $('#header').outerHeight()
//         if( direction < 0 ) {
//             $target = $( $position ).parent().next();
//         } else {
//             $target = $( $position ).parent().prev();
//         }
//         if ( $( $target.length ) !== 0 ) {
//             $( $target ).children( 'a' ).trigger( "click" );
//
//             console.log(target)
//
//
//         }
//     } );
// } )( jQuery );
// (function($) {
//     var selector = ".et_pb_section----";
//
//     var $slides = $(selector);
//
//     var currentSlide = 0;
//     var isAnimating = false;
//
//     var stopAnimation = function() {
//         setTimeout(function() {
//             isAnimating = false;
//         }, 300);
//     };
//
//     var bottomIsReached = function($elem) {
//         var rect = $elem[0].getBoundingClientRect();
//         return rect.bottom <= $(window).height();
//     };
//
//     var topIsReached = function($elem) {
//         var rect = $elem[0].getBoundingClientRect();
//         return rect.top >= 0;
//     };
//
//     document.addEventListener(
//         "wheel",
//         function(event) {
//             var $currentSlide = $($slides[currentSlide]);
//
//             if (isAnimating) {
//                 event.preventDefault();
//                 return;
//             }
//
//             var direction = -event.deltaY;
//
//             if (direction < 0) {
//                 // next
//                 if (currentSlide + 1 >= $slides.length) return;
//                 if (!bottomIsReached($currentSlide)) return;
//                 event.preventDefault();
//                 currentSlide++;
//                 var $slide = $($slides[currentSlide]);
//                 var offsetTop = $slide.offset().top - $('#header').outerHeight();
//                 isAnimating = true;
//                 $("html, body").animate(
//                     {
//                         scrollTop: offsetTop
//                     },
//                     1000,
//                     stopAnimation
//                 );
//             } else {
//                 // back
//                 if (currentSlide - 1 < 0) return;
//                 if (!topIsReached($currentSlide)) return;
//                 event.preventDefault();
//                 currentSlide--;
//                 var $slide = $($slides[currentSlide]);
//                 var offsetTop = $slide.offset().top - $('#header').outerHeight();
//                 isAnimating = true;
//                 $("html, body").animate(
//                     {
//                         scrollTop: offsetTop
//                     },
//                     1000,
//                     stopAnimation
//                 );
//             }
//         },
//         { passive: false }
//     );
// })(jQuery);

    $('a[href="#contact-us"]').on('click', function (event) {
        event.preventDefault()
        event.stopImmediatePropagation()

        $('#nav-items >div>div.dropdown-nav-item.is-open').removeClass('is-open')

        setTimeout(() => $('#header ,#et-main-area').transition({y: 400}, 600, 'easeInOutExpo'), 100)

        $('.contact-us').css('display', 'block').transition({
            height: '100vh',
            y: '0%',
        }, 800, 'easeInOutExpo')

        let line1 = $('.contact-us .line.one'),
            line2 = $('.contact-us .line.two'),
            line3 = $('.contact-us .line.three'),
            line4 = $('.contact-us .line.four')


        setTimeout(() => line1.animate({
            width: '100%',
            // opacity: 1
        }, 800, 'easeInExpo'), 800);

        setTimeout(() => line2.animate({
            width: '100%',
            // opacity: 1
        }, 700, 'easeInExpo'), 900);

        setTimeout(() => line3.animate({
            width: '100%',
            // opacity: 1
        }, 600, 'easeInExpo'), 1000);

        setTimeout(() => line4.animate({
            width: '100%',
            // opacity: 1
        }, 500, 'easeInExpo'), 1100);

        return false;
    })

    $('#close-contact-us').on('click', function (event) {
        let line1 = $('.contact-us .line.one'),
            line2 = $('.contact-us .line.two'),
            line3 = $('.contact-us .line.three'),
            line4 = $('.contact-us .line.four')

        setTimeout(() => line1.animate({
            width: '0%',
            // opacity: 0
        }, 800, 'easeOutExpo'), 0);

        setTimeout(() => line2.animate({
            width: '0%',
            // opacity: 0
        }, 700, 'easeOutExpo'), 100);

        setTimeout(() => line3.animate({
            width: '0%',
            // opacity: 0
        }, 600, 'easeOutExpo'), 200);

        setTimeout(() => line4.animate({
            width: '0%',
            // opacity: 0
        }, 500, 'easeOutExpo'), 300);


        setTimeout(() => $('.contact-us').transition({
            height: '0',
            y: '-100%',
        }, 800, 'easeInOutExpo', () => $('.contact-us').css('display', 'none')), 500)

        setTimeout(() => $('#header ,#et-main-area').transition({y: 0}, 700, 'easeInOutExpo'), 600)
    })


    jQuery(function ($) {

        if ($('body.page-id-3').length) {
            // window.scrollTo(0, 0);

            window.et_pb_smooth_scroll = function ($target, $top_section, speed, easing) {
            }

            $('a[href^="#"]').on('click', function (e) {
                e.preventDefault()
                e.stopImmediatePropagation()


                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top - $('#header').outerHeight() - ($('#wpadminbar').outerHeight() ?? 0)
                }, 800, 'swing');

                return false;
            })


        }

    });


// if($('#linkedin-social-selling-header-image').length){
//
//
//     $('.et_pb_section_0').after($('#linkedin-social-selling-header-image').detach())
//     $('#linkedin-social-selling-header-image').show()
//
// }


// function animate(element) {
//     let elementWidth = element.outerWidth(),
//
//         parentWidth = element.parent().outerWidth(),
//
//         flag = 0;
//
//
//
//     setInterval(() => {
//         let parentOffsetLeft = element.parent().offset().left,
//             offsetLeft = element.offset().left - parentOffsetLeft
//
//         element.css("transform", `translateX(${--flag}px)`);
//
//         if ((offsetLeft+elementWidth)<0) {
//             flag = parentWidth;
//         }
//         console.log({elementWidth, offsetLeft, parentWidth,flag})
//         console.log(offsetLeft+elementWidth)
//     }, 10);
// }
//
// $('.team-header_v2 .team-grid').each(function () {
//     animate($(this))
// })


    $(document).on('oninput', '.wpforms-form textarea', function () {
        this.style.height = ""; /* Reset the height*/
        this.style.height = Math.min(this.scrollHeight, 40) + "px";
    })


    const isIOS = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document),
        isMacOS = navigator.platform.indexOf('Mac') > -1

    if (isIOS) {
        $('body').addClass('ios-device')
    }

    if (isMacOS) {
        $('body').addClass('macos-device')
    }


    /**
     * Dotted map dot placer
     */
    window.moveSvgDottetMapPinTooltips = (createNew = false) => {

        window.scroller.kill()
        Fancybox.destroy()
        const getMousePosition = (event) => {
            let parent = $('#footprint-pins'),
                shiftX = event.pageX - parent.offset().left,
                shiftY = event.pageY - parent.offset().top,
                parentWidth = parent.outerWidth(),
                parentHeight = parent.outerHeight(),
                moveLeft = (shiftX * 100) / parentWidth,
                moveTop = (shiftY * 100) / parentHeight

            return {moveLeft, moveTop}
        }

        if (createNew) {
            $(document).on('click', '#footprint-pins', function (event) {
                if (!$(event.target).parents('.footprint-pin').length) {
                    // console.log(event)

                    let {moveLeft, moveTop} = getMousePosition(event),
                        newPin = `<div style="--left:${moveLeft}%; --top:${moveTop}%" class="footprint-pin editing"  data-type="client"  ><div><div data-tippy-theme="client" data-tippy-content="name"></div></div></div>`

                    $(this).append(newPin)
                    initTooltips()
                }
            })
        }
        $('.footprint-pin').addClass('editing')
        const ball = document.querySelector('.footprint-pin >div >div')

        $(document).on('mousedown', '.footprint-pin >div >div', function (event) {
            const pin = $(this)

            moveAt(event);

            // moves the ball at (pageX, pageY) coordinates
            // taking initial shifts into account
            function moveAt(event) {
                let {moveLeft, moveTop} = getMousePosition(event)
                // console.log(pageX, pageY)
                pin.parents('.footprint-pin').css('--left', moveLeft + '%').css('--top', moveTop + '%');
                pin[0].parentNode.parentNode.style.left = moveLeft + '%';
                pin[0].parentNode.parentNode.style.top = moveTop + '%';
            }

            function onMouseMove(event) {
                moveAt(event);
            }

            // move the ball on mousemove
            document.addEventListener('mousemove', onMouseMove);

            // drop the ball, remove unneeded handlers
            pin[0].onmouseup = function () {
                document.removeEventListener('mousemove', onMouseMove);
                pin[0].onmouseup = null;
            };

        });

    }

    /**
     * Use this to create a json array in the console  to generate each footprint pin and toolip
     */
    window.generateSvgDottetMapPinTooltipArray = () => {
        const footprintArray = []
        $('#our-footprint-map-v2 svg circle[data-tippy-content]').each(function (index) {

            let parent = $('#our-footprint-map-v2'),
                pin = $(this),
                pinSize = pin[0].getBoundingClientRect().width,
                shiftX = pin.offset().left - parent.offset().left + pinSize / 2,
                shiftY = pin.offset().top - parent.offset().top + pinSize / 2,
                parentWidth = parent.outerWidth(),
                parentHeight = parent.outerHeight(),
                moveLeft = (shiftX * 100) / parentWidth,
                moveTop = (shiftY * 100) / parentHeight,
                label = pin.attr('data-tippy-content'),
                theme = pin.attr('data-tippy-theme')


            let newPin = `<div style="--left:${moveLeft}%; --top:${moveTop}%; --pinSize:${pinSize + 2}px" class="footprint-pin"  data-type="${moveTop}"><div><div data-tippy-theme="${theme}" data-tippy-content="${label}"></div></div></div>`

            parent.append(newPin)

            footprintArray[index] = {
                moveLeft,
                moveTop,
                theme,
                label,
                pinSize
            }

        })
        // console.log(footprintArray)
    }

    window.generateSvgDottetMapPinTooltipArrayFromMoved = () => {
        let footprintArray = []
        $('.footprint-pin').each(function (index) {
            const moveLeft = Number($(this).css('--left').replace('%', '')),
                moveTop = Number($(this).css('--top').replace('%', '')),
                theme = $(this).find('>div>div').attr('data-tippy-theme'),
                label = $(this).find('>div>div').attr('data-tippy-content'),
                pinSize = Number($(this).css('--pinSize').replace('%', ''))

            footprintArray[index] = {
                moveLeft,
                moveTop,
                theme,
                label,
                pinSize
            }
        })

        // console.log(footprintArray)
    }

    /**
     * To add new dotted map pins, first update the svg footprint-v2.svg and set the color.
     * Then open the svg in photoshop @3000px wide.
     * Export as PNG
     * Then in browser console window run moveSvgDottetMapPinTooltips(true) and the new pins
     * Then export json generateSvgDottetMapPinTooltipArrayFromMoved() to php file shortcodes.php function fdc_global_footprint_map_v2
     */
// generateSvgDottetMapPinTooltipArrayFromMoved()
//  moveSvgDottetMapPinTooltips()


})(jQuery)
